import React from "react"
import { TouchableOpacity, StyleSheet, Text, View } from "react-native"
import { theme } from "@common/theme/theme"

/**
 * Carte visuelle compacte : emoji en haut + label en bas.
 * Sert pour les questions "niveau actuel" / "brevet blanc" / "autonomie".
 */
const BrevetVisualCard = ({
    emoji,
    label,
    subLabel,
    selected,
    onPress,
    style,
    compact = false,
}) => {
    return (
        <TouchableOpacity
            onPress={onPress}
            activeOpacity={0.7}
            style={[
                styles.card,
                compact && styles.cardCompact,
                selected && styles.cardSelected,
                style,
            ]}
        >
            <Text
                style={[styles.emoji, compact && styles.emojiCompact]}
                allowFontScaling={false}
            >
                {emoji}
            </Text>
            <Text
                style={[
                    styles.label,
                    compact && styles.labelCompact,
                    selected && styles.labelSelected,
                ]}
                numberOfLines={2}
            >
                {label}
            </Text>
            {subLabel ? (
                <Text
                    style={[
                        styles.subLabel,
                        selected && styles.subLabelSelected,
                    ]}
                    numberOfLines={1}
                >
                    {subLabel}
                </Text>
            ) : null}
        </TouchableOpacity>
    )
}

const styles = StyleSheet.create({
    card: {
        alignItems: "center",
        paddingVertical: 12,
        paddingHorizontal: 8,
        borderRadius: 12,
        borderWidth: 1.5,
        borderColor: theme.colors.lightMore,
        backgroundColor: theme.colors.white,
        minHeight: 78,
        justifyContent: "center",
    },
    cardCompact: {
        paddingVertical: 8,
        minHeight: 62,
    },
    cardSelected: {
        borderColor: theme.colors.primary,
        backgroundColor: theme.colors.primaryLighter,
    },
    emoji: {
        fontSize: 26,
        lineHeight: 32,
        marginBottom: 4,
    },
    emojiCompact: {
        fontSize: 20,
        lineHeight: 24,
        marginBottom: 2,
    },
    label: {
        fontFamily: "Montserrat-Bold",
        fontSize: 11,
        color: theme.colors.grey,
        textAlign: "center",
    },
    labelCompact: {
        fontSize: 10,
    },
    labelSelected: {
        color: theme.colors.primary,
    },
    subLabel: {
        fontFamily: "Montserrat-Regular",
        fontSize: 9,
        color: theme.colors.light,
        marginTop: 1,
    },
    subLabelSelected: {
        color: theme.colors.primary,
    },
})

export default BrevetVisualCard
